import { memo } from 'react';
import { CartesianGrid, Legend, Line, LineChart, Tooltip, XAxis, YAxis } from 'recharts';

import { ChartFrame } from '@/components/charts/ChartFrame';
import { formatCompact } from '@/lib/format';
import { TIER_COLORS } from '@/lib/tierColors';

type MrrChartProps = {
  data: { month: number; mrr: number }[];
};

const TOOLTIP_STYLE = {
  backgroundColor: 'var(--card)',
  border: '1px solid var(--border)',
  color: 'var(--card-foreground)',
  fontSize: 12,
};

export const MrrChart = memo(function MrrChart({ data }: MrrChartProps) {
  return (
    <ChartFrame>
      <LineChart data={data} margin={{ top: 4, right: 16, left: 8, bottom: 4 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
        <XAxis
          dataKey="month"
          tickFormatter={(v: number) => `M${v}`}
          tick={{ fill: 'currentColor', fontSize: 11 }}
        />
        <YAxis
          tickFormatter={formatCompact}
          tick={{ fill: 'currentColor', fontSize: 11 }}
          width={56}
        />
        <Tooltip
          formatter={(value) => (typeof value === 'number' ? [formatCompact(value), 'MRR'] : value)}
          contentStyle={TOOLTIP_STYLE}
          labelFormatter={(label) => `Mois ${String(label)}`}
        />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Line
          type="monotone"
          dataKey="mrr"
          name="MRR"
          stroke={TIER_COLORS[1]}
          dot={false}
          strokeWidth={2}
          isAnimationActive={false}
        />
      </LineChart>
    </ChartFrame>
  );
});
